import SearchInput from 'components/inputs/SearchInput';
import React, { ReactElement, useContext, useEffect } from 'react';
import AppStoreContext from 'contexts/AppStoreContext';
import { useTranslator } from '@bluebeam/react-i18n';

const RFIListSearch = (): ReactElement => {
  const { actions, state } = useContext(AppStoreContext);
  const { rfiTableQuery } = state;
  const { translate } = useTranslator(['buttons']);

  useEffect(() => {
    const resetRFISearchQuery = rfiTableQuery.set('search', '');
    actions.setRFITableQuery(resetRFISearchQuery);
  }, []);

  const handleInputChange = (searchString: string): void => {
    const nextRFIQuery = rfiTableQuery.set('search', searchString);
    actions.setRFITableQuery(nextRFIQuery);
  };

  return (
    <div>
      <SearchInput
        id="rfi-subheader-search"
        value={rfiTableQuery.search}
        placeholder={translate('buttons:search')}
        onChange={handleInputChange}
      />
    </div>
  );
};

export default RFIListSearch;
